import { ThemeProvider as EmotionThemeProvider, css, Global } from '@emotion/react';
import { theme as corgixTheme } from '@veeva/corgix/theme';
import defaultFontFamily from './fonts/defaultFontFamily';
import RobotoFontFaces from './fonts/Roboto/RobotoFontFaces';
import sizes from './theme/sizes';

const veevaIDTheme = {
    ...corgixTheme,
    ...sizes,
    fontFamily: defaultFontFamily,
    veevaIdErrorLabelBufferHeight: '3.333rem',
};

function VeevaIDThemeProvider({ children }) {
    return (
        <EmotionThemeProvider theme={veevaIDTheme}>
            <RobotoFontFaces />
            <Global
                styles={({ black, fontFamily, rootFont: rootFontSize }) => {
                    return css`
                        html,
                        body {
                            font-size: ${rootFontSize};
                            font-family: ${fontFamily};
                            color: ${black};
                            padding: 0;
                            margin: 0;
                        }
                    `;
                }}
            />
            {children}
        </EmotionThemeProvider>
    );
}

VeevaIDThemeProvider.displayName = 'VeevaIDThemeProvider';

export default VeevaIDThemeProvider;
